export default  {
    knobX: 84,
    knobY: 84,
    svg:`
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="208px" height="208px" viewBox="0 0 208 208" version="1.1">
    <!-- Generator: Sketch 47.1 (45422) - http://www.bohemiancoding.com/sketch -->
    <desc>Created with Sketch.</desc>
    <defs>
        <linearGradient x1="50%" y1="50%" x2="50%" y2="100%" id="e3899394-f981-d19d-69d7-b41c45c3b42a">
            <stop stop-color="#FFFFFF" stop-opacity="0.5" offset="0%"/>
            <stop stop-color="#000000" stop-opacity="0.5" offset="100%"/>
        </linearGradient>
        <circle id="b804ee35-dc43-9709-03a1-24cf39c7e647" cx="100" cy="100" r="100"/>
        <filter x="-3.5%" y="-3.0%" width="107.0%" height="107.0%" filterUnits="objectBoundingBox" id="f14323e4-8a35-291f-14f5-db9fd86dd5ca">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="1" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        <circle id="2fbca870-f305-1f7d-a72b-3b0dd4a823f0" cx="100" cy="100" r="88"/>
        <filter x="-4.0%" y="-3.4%" width="108.0%" height="108.0%" filterUnits="objectBoundingBox" id="9c6c0960-e015-679f-e251-caa11b4d0781">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="1" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="30e34a74-4488-048f-0ab0-33a417defeed">
            <stop stop-color="#EEEEEE" offset="0%"/>
            <stop stop-color="#EDEDED" offset="50.0553592%"/>
            <stop stop-color="#D8D8D8" offset="100%"/>
        </linearGradient>
        <circle id="fb688804-9a67-93e2-b067-7e18a63b96d0" cx="84" cy="84" r="84"/>
        <filter x="-4.2%" y="-3.6%" width="108.3%" height="108.3%" filterUnits="objectBoundingBox" id="de01d605-c195-ed0e-0ba6-1222ffc4407d">
            <feMorphology radius="0.5" operator="dilate" in="SourceAlpha" result="shadowSpreadOuter1"/>
            <feOffset dx="0" dy="1" in="shadowSpreadOuter1" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feComposite in="shadowBlurOuter1" in2="SourceAlpha" operator="out" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
        <circle id="539c6e84-e9e9-1fb0-eef6-115db06f497f" cx="84" cy="84" r="60"/>
        <filter x="-2.1%" y="-2.1%" width="104.2%" height="104.2%" filterUnits="objectBoundingBox" id="85f48179-03bf-8c38-8d8f-24f77bbaed7f">
            <feGaussianBlur stdDeviation="1.5" in="SourceAlpha" result="shadowBlurInner1"/>
            <feOffset dx="0" dy="1" in="shadowBlurInner1" result="shadowOffsetInner1"/>
            <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowInnerInner1"/>
        </filter>
        <radialGradient cx="50%" cy="50%" fx="50%" fy="50%" r="41.8108259%" id="0cf1126e-3172-f594-4903-791626b49d2a">
            <stop stop-color="#3D3D3D" offset="0%"/>
            <stop stop-color="#979191" offset="100%"/>
        </radialGradient>
        <circle id="3023b0b7-b07c-2c95-d3b5-83ecae421ab8" cx="84.502994" cy="11.0658683" r="10.0598802"/>
        <filter x="-9.9%" y="-9.9%" width="119.9%" height="119.9%" filterUnits="objectBoundingBox" id="c4505872-61de-efa8-9956-82825c5b4f0f">
            <feGaussianBlur stdDeviation="1.5" in="SourceAlpha" result="shadowBlurInner1"/>
            <feOffset dx="0" dy="1" in="shadowBlurInner1" result="shadowOffsetInner1"/>
            <feComposite in="shadowOffsetInner1" in2="SourceAlpha" operator="arithmetic" k2="-1" k3="1" result="shadowInnerInner1"/>
            <feColorMatrix values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0" type="matrix" in="shadowInnerInner1"/>
        </filter>
        <circle id="99e9fd48-43cb-0f01-ca5f-473602ea8a86" cx="84.502994" cy="11.0658683" r="7.52774751"/>
        <filter x="-19.9%" y="-19.9%" width="139.9%" height="139.9%" filterUnits="objectBoundingBox" id="f680d9d5-cc8f-3281-d2e8-42a4a22a4dfb">
            <feOffset dx="0" dy="0" in="SourceAlpha" result="shadowOffsetOuter1"/>
            <feGaussianBlur stdDeviation="1" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
            <feColorMatrix values="0 0 0 0 0.960784314   0 0 0 0 0.650980392   0 0 0 0 0.137254902  0 0 0 1 0" type="matrix" in="shadowBlurOuter1"/>
        </filter>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="s6" transform="translate(4.000000, 3.000000)">
            <g id="container">
                <g id="Oval-2">
                    <use fill="black" fill-opacity="1" filter="url(#f14323e4-8a35-291f-14f5-db9fd86dd5ca)" xlink:href="#b804ee35-dc43-9709-03a1-24cf39c7e647"/>
                    <use stroke="#979797" stroke-width="1" fill="url(#e3899394-f981-d19d-69d7-b41c45c3b42a)" fill-rule="evenodd" xlink:href="#b804ee35-dc43-9709-03a1-24cf39c7e647"/>
                </g>
                <g id="Oval-2">
                    <use fill="black" fill-opacity="1" filter="url(#9c6c0960-e015-679f-e251-caa11b4d0781)" xlink:href="#2fbca870-f305-1f7d-a72b-3b0dd4a823f0"/>
                    <use stroke="#4A4A4A" stroke-width="1" fill="#4A4A4A" fill-rule="evenodd" xlink:href="#2fbca870-f305-1f7d-a72b-3b0dd4a823f0"/>
                </g>
                <g id="knob" transform="translate(16.000000, 16.000000)">
                    <g id="Oval-2">
                        <use fill="black" fill-opacity="1" filter="url(#de01d605-c195-ed0e-0ba6-1222ffc4407d)" xlink:href="#fb688804-9a67-93e2-b067-7e18a63b96d0"/>
                        <use stroke="#979797" stroke-width="1" fill="url(#30e34a74-4488-048f-0ab0-33a417defeed)" fill-rule="evenodd" xlink:href="#fb688804-9a67-93e2-b067-7e18a63b96d0"/>
                    </g>
                    <g id="Oval">
                        <use fill="#3D3D3D" fill-rule="evenodd" xlink:href="#539c6e84-e9e9-1fb0-eef6-115db06f497f"/>
                        <use fill="black" fill-opacity="1" filter="url(#85f48179-03bf-8c38-8d8f-24f77bbaed7f)" xlink:href="#539c6e84-e9e9-1fb0-eef6-115db06f497f"/>
                        <use stroke="#454545" stroke-width="1" xlink:href="#539c6e84-e9e9-1fb0-eef6-115db06f497f"/>
                    </g>
                    <g id="Oval-3">
                        <use fill="url(#0cf1126e-3172-f594-4903-791626b49d2a)" fill-rule="evenodd" xlink:href="#3023b0b7-b07c-2c95-d3b5-83ecae421ab8"/>
                        <use fill="black" fill-opacity="1" filter="url(#c4505872-61de-efa8-9956-82825c5b4f0f)" xlink:href="#3023b0b7-b07c-2c95-d3b5-83ecae421ab8"/>
                    </g>
                    <g id="Oval-4">
                        <use fill="black" fill-opacity="1" filter="url(#f680d9d5-cc8f-3281-d2e8-42a4a22a4dfb)" xlink:href="#99e9fd48-43cb-0f01-ca5f-473602ea8a86"/>
                        <use fill="#3D3D3D" fill-rule="evenodd" xlink:href="#99e9fd48-43cb-0f01-ca5f-473602ea8a86"/>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
`
}